<template>
    <svg
        :class="{
            'icon__globe': hoverState == true
        }"
        width="16"
        height="16"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="globeIconTitle"
    >
        <title id="globeIconTitle">Globe icon</title>
        <path
            d="M2.4 2.4C3.8.8 5.9-.1 8 0c2.1-.1 4.2.8 5.6 2.4C15.2 3.8 16.1 5.9 16 8c.1 2.1-.8 4.2-2.4 5.6-1.4 1.6-3.5 2.5-5.6 2.4-2.1.1-4.2-.8-5.6-2.4C.9 12.1 0 10.1 0 8c-.1-2.1.8-4.2 2.4-5.6zm6.7 12c.8-.1 1.5-.6 2-1.2.5-.8.9-1.8.9-2.8 0-.6-.2-1.2-.7-1.6-.4-.5-1-.8-1.7-.8H8.3c-.4 0-.8-.1-1.2-.3-.3-.2-.4-.5-.4-.9 0-.2.1-.4.3-.5.1-.2.3-.3.5-.3s.5.2.6.4c.3.1.4.3.5.3.2 0 .4 0 .5-.1.2-.2.3-.4.2-.6 0-.5-.3-1-.6-1.3.4-.8.6-1.7.6-2.6 0-.1-.1-.3-.3-.3-.3-.1-.6-.2-1-.2-1.2 0-2.4.4-3.5 1.1-.8.6-1.2 1.6-1.2 2.6s.4 1.9 1.1 2.5c.7.7 1.6 1.1 2.5 1.1v.5c0 .5.2 1 .5 1.3.3.4.7.7 1.2.8V14c0 .1 0 .1.1.3.1.2.2.1.4.1z"
            fill="#F2F2F2"
            fill-rule="nonzero"
        />
    </svg>
</template>

<script>
export default {
    name: 'IconGlobe',
    props: {
        hoverState: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/all.scss';

.icon__globe {
    path {
        transition: all 0.3s ease;
    }
    &:hover {
        path {
            fill: $primary;
        }
    }
}
</style>
